import { render, staticRenderFns } from "./DocumentsAdminProjects.vue?vue&type=template&id=9c5de1b0"
import script from "./DocumentsAdminProjects.vue?vue&type=script&lang=ts"
export * from "./DocumentsAdminProjects.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c5de1b0')) {
      api.createRecord('9c5de1b0', component.options)
    } else {
      api.reload('9c5de1b0', component.options)
    }
    module.hot.accept("./DocumentsAdminProjects.vue?vue&type=template&id=9c5de1b0", function () {
      api.rerender('9c5de1b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/documents/admin/DocumentsAdminProjects.vue"
export default component.exports